/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";

class PipelineSuctionBottomBtns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isIphoneX: utils.isIphoneX() || utils.isIphone14ProMax()
    };
    this.isShihuo = utils.isShihuo();
  }

  componentDidMount() {
    this.setPadding();
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const options = {
      link: item.link,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);

  };

  render() {
    const { isIphoneX } = this.state;
    const { btnsList } = this.props.config;

    return (
      <div
        className="pipeline-suctionBottomBtns"
        {...this.props['customAttributes']}
        style={{
          paddingBottom: this.isShihuo && isIphoneX ? "34px" : 0
        }}
      >
        {
          btnsList.map((item, index) => {
            return (
              <div className="btn-item" key={index} onClick={() => this.handleItemClick(item, index)}>
                <img src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
              </div>
            )
          })
        }
      </div>
    );
  }

  setPadding() {
    if (this.state.isIphoneX) {
      document.getElementsByTagName("body")[0].style.paddingBottom = "120px";
    } else {
      document.getElementsByTagName("body")[0].style.paddingBottom = "70px";
    }
  }
}

PipelineSuctionBottomBtns.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSuctionBottomBtns };
export default PipelineSuctionBottomBtns;



// WEBPACK FOOTER //
// ./components/pipeline-suctionBottomBtns/index.js